<template>
	<div class="sf-datatable-wrapper">
		<sf-data-table
			ref="dataTable"
			index
			:scrId="scrId"
			:paging="false"
			:columns="columns"
			:rows="rows"
			:stripe="false"
			style="height: 260px"
		>
		</sf-data-table>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RoApcn/store/helpers';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.cmpnMstList;
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001024'), //캠페인번호
					prop: 'cmpnNo',
					minWidth: '180px',
					sortable: false,
					highlight: true,
					clickEvent: this.clickCmpnNo
				},
				{
					label: this.getMessage_('QWCC001007'), // 캠페인명
					prop: 'cmpnNm',
					minWidth: '150px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001198'), // 원인부품품명
					prop: 'causPartNm',
					minWidth: '200px',
					sortable: true
				},
				// {
				// 	label: this.getMessage_('QWCC001050'), // 발생지역
				// 	prop: 'occuRegn',
				// 	minWidth: '150px',
				// 	sortable: true
				// },
				{
					label: this.getMessage_('QWCC001025'), // 캠페인 시작일
					prop: 'strtDd',
					minWidth: '150px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001026'), //캠페인 종료일
					prop: 'endDd',
					minWidth: '150px',
					sortable: true
				}
				// {
				// 	label: this.getMessage_('QWCC000001'), // 캠페인 교환부품수량
				// 	prop: 'partNoCount',
				// 	minWidth: '150px',
				// 	sortable: true
				// }
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async clickCmpnNo(row) {
			await this.setCmpnOpCdInit_();

			if (row.partNoCount == 0) {
				//교환부품수량이 존재하지 않는 캠페인입니다
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001872') });
			} else {
				const cmpnNm = row.cmpnNm;
				const cmpnNo = row.cmpnNo;

				this.$sf_toggleLoading(true);
				await this.setState_({ key: 'selectedCmpnNm', value: cmpnNm });
				await this.getCmpnMstPopList_(cmpnNo).finally(() => this.$sf_toggleLoading(false));
			}
		}
	}
};
</script>
